import { render, staticRenderFns } from "./LoginPhoneView.vue?vue&type=template&id=3b3099fe&scoped=true&"
import script from "./LoginPhoneView.vue?vue&type=script&lang=js&"
export * from "./LoginPhoneView.vue?vue&type=script&lang=js&"
import style0 from "./LoginPhoneView.vue?vue&type=style&index=0&id=3b3099fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3099fe",
  null
  
)

export default component.exports